import React from "react";

import ModalTab from "app/components/Modal/ModalTab";

export default ({ title, Icon, input, index, selected }) => {
  const { onChange } = input;

  return (
    <ModalTab
      Icon={Icon}
      value={index}
      title={title}
      selected={selected}
      onClick={val => onChange(val)}
    ></ModalTab>
  );
};
